{
  "0_ALREADY_EXISTS": "\"{0}\" bestaat al.",
  "0_OF_1": "{0} van {1}",
  "ACCOUNT_ID": "Account-ID",
  "ADD": "Toevoegen",
  "ADD_REMOVE_FIELDS": "Velden toevoegen/verwijderen",
  "AN_ERROR_OCCURED": "Er is een fout opgetreden",
  "APPLY": "Toepassen",
  "APPLY_CHANGES": "Wijzigingen toepassen",
  "ATTACH": "Toevoegen",
  "ATTACH_AS_LINK": "Toevoegen als koppeling",
  "ATTACHING": "Bezig met toevoegen...",
  "AUTOMATICALLY_RENAME": "Automatisch hernoemen",
  "BACK": "Terug",
  "BROWSE": "Bladeren",
  "CANCEL": "Annuleren",
  "CHARACTER_COUNT": "Aantal tekens:",
  "CLOSE": "Sluiten",
  "CLOUD": "Cloud",
  "COMMENT": "Opmerking",
  "CONFIGURE_REPOSITORY_SETTINGS": "Repository-instellingen configureren",
  "COULD_NOT_SAVE_0": "Kon \"{0}\" niet opslaan.",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Kon \"{0}\" niet opslaan. Bestandstype wordt niet ondersteund.",
  "DATA": "Gegevens",
  "DATE": "Datum",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Datumvelden moeten het formaat {0} hebben.",
  "DATE_PROVIDED_IS_INVALID": "De opgegeven datum is ongeldig.",
  "DATE_TIME": "Datum/Tijd",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Datum-/tijdvelden moeten het formaat {0} hebben.",
  "DEFAULT_FOLDER": "<Standaardmap>",
  "DETAILS": "Details",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Wilt u uw veldwijzigingen toepassen?",
  "DOCUMENT_NAME_IS_EMPTY": "Documentnaam is leeg",
  "DRAG_DROP_FILE": "Bestand slepen en neerzetten",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Er bestaat al een item met de naam '{0}' in deze map. Kies alstublieft een andere naam.",
  "ENTRY_ID": "Item-ID",
  "ENTRY_NAME": "Itemnaam",
  "ENTRY_NOT_FOUND": "Invoer niet gevonden.",
  "ERROR_DOWNLOADING_DOCUMENT": "Fout bij het downloaden van het document.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Er is een fout opgetreden bij het verbinden met de server.",
  "ERROR_SAVING": "Fout bij opslaan:",
  "FAILED_TO_OPEN_FOLDER": "Map openen mislukt",
  "FAILED_TO_SAVE_COLON": "Opslaan mislukt:",
  "FAILED_TO_SAVE_PERIOD": "Opslaan mislukt.",
  "FEEDBACK": "Feedback",
  "FIELDS": "Velden",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Dit bestand overschrijdt de maximale bestandsgrootte van 25MB.",
  "FILE_EXTENSION": "Bestandsextensie",
  "FILE_LOCKED": "Bestand is vergrendeld.",
  "FILE_MODIFIED": "Bestand gewijzigd",
  "FILE_NAME": "Bestandsnaam",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Bestandsnamen mogen geen backslash bevatten",
  "FOLDER": "Map",
  "INTEGER": "Geheel getal",
  "LIST": "Lijst",
  "LOADING": "Bezig met laden...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Long-velden moeten gehele getallen zijn tussen 0 en 3.999.999.999",
  "LONG_INTEGER": "Long Integer",
  "NAME": "Naam",
  "NAME_CONFLICT": "Naamconflict",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Hulp nodig bij aanmelden? Neem contact op met uw Laserfiche-beheerder voor hulp.",
  "NEW_FOLDER": "Nieuwe map",
  "NO": "Nee",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Geen extra velden toegewezen",
  "NO_FOLDER_SELECTED": "Er is geen map geselecteerd.",
  "NO_MATCHING_ENTRIES_FOUND": "Geen overeenkomende items gevonden",
  "NO_MATCHING_FIELDS_FOUND": "Er zijn geen overeenkomende velden gevonden.",
  "NO_TEMPLATE_ASSIGNED": "Geen sjabloon toegewezen",
  "NOT_AVAILABLE_WITH_TOKENS": "Niet beschikbaar met tokens",
  "NUMBER": "Nummer",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Getalveld moet een geldig nummer zijn",
  "OK": "Oké",
  "ONE_OR_MORE_FIELDS_INVALID": "Een of meer velden zijn ongeldig.",
  "OPEN": "Openen",
  "OPEN_IN_LASERFICHE": "Openen in Laserfiche",
  "OPTIONAL": "Optioneel",
  "OR": "of",
  "PARENT_FIELD": "Ouder veld",
  "PARENT_ID": "Bovenliggende ID",
  "PARENT_NAME": "Naam bovenliggende",
  "PLEASE_SELECT_A_FOLDER": "Selecteer alstublieft een map",
  "REASON_FOR_DOWNLOADING": "Reden voor downloaden",
  "REFRESH": "Vernieuwen",
  "REMOVE": "Verwijderen",
  "REMOVE_REPOSITORY": "Repository verwijderen?",
  "REPOSITORY": "Repository",
  "REPOSITORY_COUNT": "Aantal repositories",
  "REPOSITORY_ID": "Repository-ID",
  "REPOSITORY_NAME": "Repository-naam",
  "REQUIRED": "Vereist",
  "REQUIRED_FIELD_IS_EMPTY": "Verplicht veld is leeg",
  "SAVE_CHANGES": "Wijzigingen opslaan",
  "SAVE_TO_LASERFICHE": "Opslaan in Laserfiche",
  "SAVED_TO_LASERFICHE": "Opgeslagen in Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Opgeslagen in Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "Opgeslagen met ontbrekende metadata:",
  "SAVING": "Bezig met opslaan...",
  "SEARCH_FIELDS": "Zoekvelden",
  "SELECT": "Selecteren",
  "SELECT_REASON": "Selecteer een reden",
  "SELF_HOSTED": "Zelf gehost",
  "SESSION_COUNT": "Aantal sessies",
  "SETTINGS": "Instellingen",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Short-velden moeten gehele getallen zijn tussen 0 en 64999",
  "SIGN_IN": "Aanmelden",
  "SIGN_IN_TO_LASERFICHE": "Aanmelden bij Laserfiche",
  "SIGN_OUT": "Afmelden",
  "SIGNING_IN": "Aan het aanmelden...",
  "SIGNING_OUT": "Afmelden...",
  "SKIP_THIS_FILE": "Dit bestand overslaan",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Er is iets misgegaan. Probeer het later opnieuw.",
  "SUBMIT": "Verzenden",
  "SUGGESTION": "Suggestie",
  "TEMPLATE": "Template",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Het sjabloon kon niet worden geladen.",
  "TEXT": "Tekst",
  "THANK_YOU_FOR_SUBMISSION": "Dank u voor uw inzending!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Dit veld heeft een maximale toegestane lengte van {0} tekens.",
  "THIS_FOLDER_IS_EMPTY": "Deze map is leeg.",
  "TIME": "Tijd",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Tijdvelden moeten het formaat {0} hebben.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Kan niet alle velden laden:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Kan repository-informatie niet ophalen:",
  "UNKNOWN_ERROR": "Onbekende fout.",
  "USER_NAME": "Gebruikersnaam",
  "YES": "Ja"
}
